// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"a02a3297","111":"5218e63e","194":"23d84885","836":"17ecff66"}[chunkId] + ".chunk.js";
};